import React, { FunctionComponent } from 'react';
import { Icon, IconsProvider, showToast } from '@ovotech/element-v5';
import { Box, Code, CopyButton } from './CodeBox.styled';

// Element 5.1.4 has no `copy` icon (added in a later version). Register the
// icon Element uses via a scoped IconsProvider so `<Icon name="copy" />` works.
// TODO: drop this and use Element's `LargeValueReference` once ovo-account-web
// is on Element >= 5.7.0 / React 19.
const Copy: FunctionComponent<JSX.IntrinsicElements['svg']> = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.5 5.075v7.588l-1.5.402v-6.49H6.507v6.493h6.491l.402 1.5H6.167a1.16 1.16 0 0 1-1.16-1.16V6.235c0-.64.519-1.16 1.16-1.16H14.5ZM10.993 1.5v2.566h-1.5V3H3v6.493h.999v1.5H1.499V2.661c0-.641.52-1.161 1.161-1.161h8.333Z"
    />
  </svg>
);

const customIcons = { copy: Copy };

type Props = {
  code: string;
  accessibilityLabel?: string;
};

export const CodeBox = ({ code, accessibilityLabel }: Props) => (
  <Box aria-label={accessibilityLabel}>
    <Code data-dd-privacy="mask">{code}</Code>
    <IconsProvider icons={customIcons}>
      <CopyButton
        type="button"
        aria-label="Copy to clipboard"
        onClick={() => {
          navigator.clipboard.writeText(code);
          showToast({ message: 'Code copied' });
        }}
      >
        <Icon name="copy" size={20} />
      </CopyButton>
    </IconsProvider>
  </Box>
);
